import React from 'react';
import ReactDOM from 'react-dom/client';

import TravelSearchCompact from './TravelSearchCompact';

const root = ReactDOM.createRoot(
  document.getElementById('travel_search_compact')
);

root.render(
  <React.StrictMode>
    <TravelSearchCompact />
  </React.StrictMode>
);
